// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b5f594b0","455":"d098a711","644":"494eeccc"}[chunkId] + ".chunk.js";
};